module.exports = __webpack_public_path__ + "img/logo-white-2x.e5cb654e.png";